export default "__VITE_ASSET__Du9tlk6M__"